import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import AppointmentPrice from './AppointmentPrice.js';

const AppointmentPriceContainer = (_param)=>{
    var { amount , currency , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "amount",
        "currency",
        "className"
    ]);
    const { isAppointmentBookingTypeWithFreeIndication  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const isFree = React.useMemo(()=>amount === 0
    , [
        amount
    ]);
    const labels = React.useMemo(()=>({
            freeIndication: isAppointmentBookingTypeWithFreeIndication && isFree ? `${getLabel('common.free')}` : ''
        })
    , [
        isAppointmentBookingTypeWithFreeIndication,
        isFree,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentPrice, swcHelpers.extends({}, {
        amount,
        currency,
        labels,
        className
    }, rest));
};

export { AppointmentPriceContainer as default };
//# sourceMappingURL=AppointmentPriceContainer.js.map
